import { switchMap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from 'app/shared/common/base-component';


@Component({
  selector: 'detect-browser-android',
  templateUrl: './detect-browser.component.html',
  styleUrls: ['./detect-browser.component.scss']
})
export class DetectBrowserAndroid  extends BaseComponent implements OnInit  {

  errMessageVisible: boolean = false;
  errMessage: string = "";
  
  constructor(
    protected router: Router,
    private activeRoute: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {

  }

  public openChrome() {
    window.location.href= "market://details?id=com.android.chrome";
  }

  public openSamsung() {
    window.location.href= "market://details?id=com.sec.android.app.sbrowser";

  }

}
